module.exports = __webpack_public_path__ + "img/music_thumbnail-600x450.18bf5a9e.jpg";